import './Split.css';
import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';

interface Props extends GlobalProps {
  children: React.ReactNode;
  ratio?: number;
}

export function Split({ children, className, style, ratio = 0.5 }: Props): JSX.Element {
  return (
    <>
      <div className={classnames('split', className)} style={style}>
        {React.Children.map(children, (child, index) => (
          <div className="split__child" style={{ flex: index === 0 ? ratio : 1 - ratio }}>
            {child}
          </div>
        ))}
      </div>
    </>
  );
}
